import React from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import styled from "styled-components";

const Wrapper = styled(Div)`

`;

function Card({ style, padding, margin, width, children }) {
  return (
    <Wrapper
      shadow="3"
      p={padding}
      maxW={width}
      style={ style ? style : null }
    >
      { children }
    </Wrapper>
  )
}

export default Card
